import { api } from './api-core';

export interface IDashboard {
    currentRankLeaderboard: ICurrentRankLeaderBoard;
    infomationUser: IDashboardMetrics;
 } 

export interface IDashboardMetrics {
    count: string;
    totalActivityCompleted: string;
    totalActivityDue: string;
    totalCourseCompleted: number;
    totalBadges: number;
    totalContests: number;
    data: {
        completionPercentage: string
        course_image: string
        coursename: string
        id: string
        last_access_time: string
        numberActivityCompletion: string
        summary: string
        totalActivityDue: string
        view_url: string
    }[];
 } 

export interface ICurrentRankLeaderBoard {
    beginner: any[];
    checkUserJoinAnyContest: {
        code: string
        data: {
            status: string
        }
        status: string
    };
    contest: {
        status: string
        count: string
        total: string
        data: {
            course_digitaltwin: string
            description: string
            enable: string
            end_date: string
            event_type: string
            excerpt: string
            id: string
            image_url: string
            level: string
            level_id: string
            messageRegister: string
            participation_status: string
            publish: string
            publish_date: string
            slug: string
            start_date: string
            title: string
            updated_at: string
        }[]
        digitalLevel:{
            created_at: string
            id: string
            name: string
            updated_at: string
        }[]
    };
    current_contest: {
        course_digitaltwin: string
        description: string
        enable: string
        end_date: string
        event_type: string
        excerpt: string
        id: string
        image_url: string
        level: string
        level_id: string
        messageRegister: string
        participation_status: string
        publish: string
        publish_date: string
        slug: string
        title: string
        start_date: string
        updated_at: string
    }
    current_rank: string
    errorType: string
    message: string
    orgid: string
    totalActivity: string
    total_participant: string
    }

export interface IDashboardUserBadge {
    count: string;
    total_pages: string;
    data: {
        badgeDescription: string
        badgeIamge: string
        badgeId: number
        badgeName: string
        badgeView: string
        type: string
    }[];
    } 

export interface IDashboardUserCourse {
    status: boolean,
    message: string,
    data: {
        totalpage: string;
        currentpage: string;
        total_course_enrolled: string;
        total_course_completed: string;
        total_activity_completed: string;
        total_activity_due: string;
        course_details: {
            completionPercentage: number
            course_image: string
            coursename: number
            id: number
            last_access_time: string
            numberActivityCompletion: number
            total_activity_completion: number
            summary: string
            totalActivity: number
            total_activity: number
            total_activity_due: number
            view_url: string
        }[];
    }
} 

export interface ILeaderBoard {
    contest: {
        status: boolean;
        count: number;
        total: number;
        data: {
            course_digitaltwin: number;
            description: string;
            enable: number;
            end_date: string;
            event_type: string;
            excerpt: string;
            id: number;
            image_url: string;
            level: string;
            level_id: number;
            messageRegister: string;
            participation_status: number;
            publish: number;
            publish_date: string;
            slug: string;
            start_date: string;
            title: string;
            updated_at: string;
        }[];
        digitalLevel: {
            created_at: string;
            id: number;
            name: string;
            updated_at: string;
        }[];
    };
    level_id_data: {
        [key: string]: {
            totalActivity: number;
            numberActivityCompletion: number;
            completionPercentage: number;
            latestTimeCompleted: string;
        };
    };
    errorType: string;
    message: string;
    orgid: number;
    rankData: {
        organization_id: number;
        contest_id: number;
        level_id: number;
        username: string;
        email: string;
        effort_score: number;
        performance_score: number;
        challenge_score: number;
        total_score: number;
        rank: number;
        count_activity: number;
        total_activity: number;
    }[];
    listLevelUser: number[];
    progessBeginner: number;
}

export interface IDashboardUserContest {
    count: string;
    data: {
        conteststatus: number
        description: string
        end_date: string
        id: number
        namecategory: string
        nameorganizer: string
        slug: string
        start_date: string
        thumbnail: string
        title: string
    }[];
    status: boolean;
 } 

export interface IDashboardOrtherCourseContest {
    count: string;
    data: {
        course_image: string
        coursename: string
        id: number
        summary: string
        view_url: string
        type: string
    }[];
} 

export interface IDashboardIndonesiaCompetitonCourses {
    status: boolean,
    message: string,
    data: {
        totalpage: string;
        currentpage: string;
        courses: {
            id: number;
            fullname: string;
            displayname: string;
            shortname: string;
            categoryid: number;
            categoryname: string;
            summary: string;
            overviewfiles: {
                filename: string
                filepath: string
                filesize: number
                fileurl: string
                timemodified: number
                mimetype: string
            }[];
            customfields: {
                name: string
                shortname: string
                type: string
                valueraw: string
                value: string
            }[];
            visible: number;
            startdate: number;
            enddate: number;
        }[];
    }
} 

export interface IDashboardCheckPaymentStatusApiExtend {
    code: string,
    status: string,
    message: string,
    data: {
        check_course_order: boolean;
        order_status: number;
    }[];
} 

export const DashboardApi = {
    getDashboard: () => {
        return api.get(process.env.API_GET_DASHBOARD as string).then((res) => {
            return res.data || [];
        }).catch((err) => {
            console.log(err);
            return [];
        });
    },
    getDashboardMetrics: () => {
        return api.get(process.env.API_GET_DASHBOARD_METRICS as string).then((res) => {
            return res.data || [];
        }).catch((err) => {
            console.log(err);
            return [];
        });
    },
    getCurrentRankLeaderBoard: () => {
        return api.get(process.env.API_GET_CURRENT_RANK_LEADERBOARD as string).then((res) => {
            return res.data || [];
        }).catch((err) => {
            console.log(err);
            return [];
        });
    },
    getDataLeaderBoard: () => {
        return api.get(process.env.API_GET_USER_LEADERBOARD as string).then((res) => {
            return res.data || [];
        }).catch((err) => {
            console.log(err);
            return [];
        });
    },
    getDashboardUserBadge: (page: string, pageSize: string) => {
        const url = `${process.env.API_GET_USER_BADGE_DASHBOARD}?page=${page}&pageSize=${pageSize}`;
        return api.get(url as string).then((res) => {
            return res.data || [];
        }).catch((err) => {
            console.log(err);
            return [];
        });
    },
    getDashboardUserCourse: (page: string, pageSize: string) => {
        const url = `${process.env.API_GET_USER_COURSE_DASHBOARD}?page=${page}&pageSize=${pageSize}`;
        return api.get(url as string).then((res) => {
            return res.data || [];
        }).catch((err) => {
            console.log(err);
            return [];
        });
    },
    getDashboardIndonesiaCompetitonCourses: (page: string, pageSize: string) => {
        const url = `${process.env.API_GET_INDONESIA_COMPETITION_COURSE_DASHBOARD}?&categoryids=${process.env.CATEGORY_COURSE_COMPETITION}&page=${page}&pageSize=${pageSize}`;
        return api.get(url as string).then((res) => {
            return res.data || [];
        }).catch((err) => {
            console.log(err);
            return [];
        });
    },
    checkPaymentStatusApi: (course_id: string) => {
        const url = `${process.env.API_CHECK_STATUS_ORDER_COURSE}?&course_id=${course_id}`;
        return api.get(url as string).then((res) => {
            return res.data || [];
        }).catch((err) => {
            console.log(err);
            return [];
        });
    },
    getDashboardUserContest: (page: string, pageSize: string) => {
        const url = `${process.env.API_GET_USER_CONTEST}?page=${page}&pageSize=${pageSize}`;
        return api.get(url as string).then((res) => {
            return res.data || [];
        }).catch((err) => {
            console.log(err);
            return [];
        });
    },
    getDashboardOrtherCourseContest: () => {
        const url = `${process.env.API_GET_ORTHER_COURSE_CONTEST}`;
        return api.get(url as string).then((res) => {
            return res.data || [];
        }).catch((err) => {
            console.log(err);
            return [];
        });
    }
}